import { createSlice } from "@reduxjs/toolkit";
import { IExportPackingInitialState } from "./ExportPackingModel";
import {
  createExportPacking,
  getAllExportPacking,
  getAllPendingExportSO,
  getExportPackingItemByID,
  updateExportPackingItem,
} from "./services/exportPacking.services";

const initialState: IExportPackingInitialState = {
  loading: false,
  error: "",
  formLoading: false,
  ExportPackingItemID: "",
  PoNo: "",
  ExportPackingOrderList: [],
  PendingSalesOrderList: [],
  ExportPackingItemDetail: {
    export_sales_order_item_id: null,
    item_id: null,
    packing_weight: null,
    unit_id: null,
    packing_size: null,
    quantity_ctn: null,
    total_weight: null,
    sr_no: "",
    gross_kg: null,
    net_kg: null,
    gross_weight: null,
    net_weight: null,
  },
};

const exportPackingSlice = createSlice({
  name: "exportpacking",
  initialState,
  reducers: {
    setExportPackingItemDetail: (state, action) => {
      state.ExportPackingItemDetail = action.payload;
    },
    clearExportPackingItemDetail: (state) => {
      state.ExportPackingItemDetail = initialState.ExportPackingItemDetail;
    },
    setExportPackingItemID: (state, action) => {
      state.ExportPackingItemID = action.payload;
    },
    clearExportPackingItemID: (state) => {
      state.ExportPackingItemID = initialState.ExportPackingItemID;
    },
    setPoNo: (state, action) => {
      state.PoNo = action.payload;
    },
    clearPoNo: (state) => {
      state.PoNo = initialState.PoNo;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllExportPacking.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAllExportPacking.fulfilled, (state, action: any) => {
      state.loading = false;
      state.ExportPackingOrderList = action.payload || [];
    });
    builder.addCase(getAllExportPacking.rejected, (state, action) => {
      state.loading = false;
      state.ExportPackingOrderList = [];
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(createExportPacking.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createExportPacking.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createExportPacking.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateExportPackingItem.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateExportPackingItem.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateExportPackingItem.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getExportPackingItemByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getExportPackingItemByID.fulfilled,
      (state, action: any) => {
        state.loading = false;
        state.ExportPackingItemDetail = action.payload;
      }
    );
    builder.addCase(getExportPackingItemByID.rejected, (state, action) => {
      state.loading = false;
      state.ExportPackingItemDetail = initialState.ExportPackingItemDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllPendingExportSO.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAllPendingExportSO.fulfilled, (state, action: any) => {
      state.loading = false;
      state.PendingSalesOrderList = action.payload || [];
    });
    builder.addCase(getAllPendingExportSO.rejected, (state, action) => {
      state.loading = false;
      state.PendingSalesOrderList = [];
      state.error = action.error.message || "Something went wrong";
    });
  },
});
export const {
  setExportPackingItemDetail,
  clearExportPackingItemDetail,
  setExportPackingItemID,
  clearExportPackingItemID,
  setPoNo,
  clearPoNo,
} = exportPackingSlice.actions;
export default exportPackingSlice.reducer;
